// extracted by css-extract-rspack-plugin
export default {"wrapper":"TextWithTooltip-module__wrapper--Bo90P"};